<template>
  <div class="container">
    <div class="zero-main-top flex flex-cloum fixed">
      <div class="flex align-items space-between">
        <div class="zert-top-left flex align-items">
          <div class="zero-top-img">
            <img v-lazy="iconImg" alt="" />
          </div>
          <div class="zero-top-text">
            <div>免单卡</div>
            <div class="count">
              <span class="fs-34">{{ freeCardNum }}</span> 张
            </div>
          </div>
        </div>
        <div class="zero-top-btn" @click="checkCardDetail">查看明细</div>
      </div>
      <div class="zero-top-btm-btn" @click="goZeroBuyPage">前往0元专区，兑换免费商品</div>
    </div>
    <!-- 领卡中心 -->
    <div class="collar-wrap">
      <div class="collar-box">
        <div class="collar-title">领卡中心</div>
        <!-- 赠送好友 状态1 -->
        <div class="collar-item">
          <div class="flex align-items">
            <div class="iconfont icon-yaoqing2 sent-friend"></div>
            <div class="collar-desc">
              <div class="collar-desc-title">
                赠送好友&nbsp;
                <span v-if="friendCardNum > 0" class="t_20a0ff" @click="toSend">去赠送</span>
              </div>
              <div class="collar-desc-tip">好友成功领取，即可获得 {{ recommendCards }} 张卡</div>
            </div>
          </div>
          <div v-if="friendCardNum > 0" class="collar-btn" @click="receiveCard(0)">
            领取
            <soho-badge :number="friendCardNum" class="numTag"></soho-badge>
          </div>
          <div v-else class="collar-btn" @click="toSend">去赠送</div>
        </div>
        <!-- 新人礼包 状态1 -->
        <div class="collar-item" v-if="!IsRegisterReceive">
          <div class="flex align-items">
            <div class="iconfont icon-lipin"></div>
            <div class="collar-desc">
              <div class="collar-desc-title">新人礼包</div>
              <div class="collar-desc-tip">新用户注册，即可获得 1 张卡</div>
            </div>
          </div>
          <div v-if="loginState" class="collar-btn" @click="receiveCard(1)">领取</div>
          <div v-else class="collar-btn" @click="toRegister">去注册</div>
        </div>
        <!-- 首次提现 状态1 -->
        <div class="collar-item" v-if="MoneyCardState !== 2">
          <div class="flex align-items">
            <div class="iconfont icon-xinyongqia1"></div>
            <div class="collar-desc">
              <div class="collar-desc-title">首次提现</div>
              <div class="collar-desc-tip">完成首单购买，提现后得 1 张</div>
            </div>
          </div>
          <div v-if="MoneyCardState === 1" class="collar-btn" @click="receiveCard(2)">
            领取
            <soho-badge :number="1" class="numTag"></soho-badge>
          </div>
          <div v-else class="collar-btn" @click="toBuy">去购买</div>
        </div>
        <!-- 新人礼包和首次提现免单卡 未领取 ---- 每周福利 状态1 -->
        <div class="collar-item" v-if="(IsRegisterReceive || MoneyCardState <= 1) && userLevel >= 2 && !everyWeekIsReceive">
          <div class="flex align-items">
            <div class="iconfont icon-xin"></div>
            <div class="collar-desc">
              <div class="collar-desc-title">
                每周福利&nbsp;
                <span v-if="userLevel <= 2" class="t_20a0ff" @click="goUpgradeDetail">如何升级？</span>
              </div>
              <div class="collar-desc-tip">
                <template v-if="userLevel === 1">成为V2会员，每周赠送 1 张卡</template>
                <template v-else-if="userLevel === 2">成为V3会员，每周赠送 2 张卡</template>
                <template v-else>V3会员，每周赠送 2 张卡</template>
              </div>
            </div>
          </div>
          <div class="collar-btn" v-if="!everyWeekIsReceive" @click="receiveCard(3)">
            领取
            <soho-badge :number="weeklyCardNum" class="numTag"></soho-badge>
          </div>
        </div>
        <!-- 关注兄弟公众号 未关注或者待领取 状态1 -->
        <div class="collar-item" v-if="FreeCardGetStateForWyfl !== 2 && WyflActiveState">
          <div class="flex align-items">
            <div class="iconfont icon-pengyouquan1"></div>
            <div class="collar-desc">
              <div class="collar-desc-title">
                关注兄弟公众号&nbsp;
                <span class="t_20a0ff" @click="checkAboutFollow" v-if="FreeCardGetStateForWyfl === 1">查看</span>
              </div>
              <div class="collar-desc-tip">购物领券赚收益，关注得 1 张</div>
            </div>
          </div>
          <div v-if="FreeCardGetStateForWyfl === 1" class="collar-btn" @click="WyflSubscribeFreeCardGain">领取</div>
          <div class="collar-btn" @click="checkAboutFollow" v-else>去关注</div>
        </div>
        <!-- 新人礼包 状态2 -->
        <div class="collar-item" v-if="IsRegisterReceive">
          <div class="flex align-items">
            <div class="iconfont icon-lipin"></div>
            <div class="collar-desc">
              <div class="collar-desc-title">新人礼包</div>
              <div class="collar-desc-tip">新用户注册，即可获得 1 张卡</div>
            </div>
          </div>
          <div class="collar-btn cancel">已领取</div>
        </div>
        <!-- 首次提现 状态2 -->
        <div class="collar-item" v-if="MoneyCardState === 2">
          <div class="flex align-items">
            <div class="iconfont icon-xinyongqia1"></div>
            <div class="collar-desc">
              <div class="collar-desc-title">首次提现</div>
              <div class="collar-desc-tip">完成首单购买，提现后得 1 张</div>
            </div>
          </div>
          <div class="collar-btn cancel">已领取</div>
        </div>
        <!-- 新人礼包和首次提现免单卡 未领取 ---- 每周福利 状态1 -->
        <div class="collar-item" v-if="(IsRegisterReceive || MoneyCardState <= 1) && !(userLevel >= 2 && !everyWeekIsReceive)">
          <div class="flex align-items">
            <div class="iconfont icon-xin"></div>
            <div class="collar-desc">
              <div class="collar-desc-title">
                每周福利&nbsp;
                <span v-if="userLevel <= 2" class="t_20a0ff" @click="goUpgradeDetail">如何升级？</span>
              </div>
              <div class="collar-desc-tip">
                <template v-if="userLevel === 1">成为V2会员，每周赠送 1 张卡</template>
                <template v-else-if="userLevel === 2">成为V3会员，每周赠送 2 张卡</template>
                <template v-else>V3会员，每周赠送 2 张卡</template>
              </div>
            </div>
          </div>
          <div v-if="userLevel < 2" class="collar-btn cancel">领取</div>
          <div class="collar-btn cancel" v-else>剩余{{ showLastTime }}</div>
        </div>
        <!-- 关注兄弟公众号 关注及已领取 -->
        <div class="collar-item" v-if="FreeCardGetStateForWyfl === 2 && WyflActiveState">
          <div class="flex align-items">
            <div class="iconfont icon-pengyouquan1"></div>
            <div class="collar-desc">
              <div class="collar-desc-title">
                关注兄弟公众号&nbsp;
                <span class="t_20a0ff" @click="checkAboutFollow">查看</span>
              </div>
              <div class="collar-desc-tip">购物领券赚收益，关注得 1 张</div>
            </div>
          </div>
          <div class="collar-btn cancel">已领取</div>
        </div>
        <!-- end -->
      </div>
    </div>
  </div>
</template>

<script>
import { Indicator, MessageBox } from 'mint-ui'
import { mapGetters, mapMutations } from 'vuex'
import { FreeCardIndex, BuyerFreeCardGain, GetWeekWelfareInfo, WyflSubscribeFreeCardGain } from '@/api/zeroBuy'
import { GetRecommendSendQty } from '@/api/my'
import { IMG_BASE_URL } from '@/config'
import moment from 'moment'

export default {
  data() {
    return {
      iconImg: IMG_BASE_URL + '/upaiyun/Sys/20181217/4737334625133973679.png',
      // 免单卡数量
      freeCardNum: 0,
      // 可领取免单卡数量
      friendCardNum: 0,
      // 新人注册是否领取免单卡
      IsRegisterReceive: false,
      // 首次提现免单领取状态
      MoneyCardState: 0,
      // 用户等级
      userLevel: 1,
      // 每周福福利是否领取
      everyWeekIsReceive: false,
      // 每周福利未领取数
      weeklyCardNum: 0,
      // 邀请好友赠送的免单卡数
      recommendCards: 0,
      showLastTime: '',
      // 关注兄弟公众号
      // 活动免单卡领取状态
      FreeCardGetStateForWyfl: 0, // 未关注=0、待领取=1、已领取=2
      // 万有返利关注活动开启状态
      WyflActiveState: false,
      // 关注万有返利公众号文章地址
      wyflFollowLink: ''
    }
  },
  mounted() {
    if (this.loginState) {
      this.updateData()
    }
  },
  computed: {
    ...mapGetters(['getIsAuthorized', 'getIsApp', 'loginState', 'getIfShowAppDownloadGuide'])
  },
  methods: {
    ...mapMutations(['AUTHORIZE_POPUP_SHOW', 'SET_IF_SHOW_APP_DOWNLOAD_GUIDE', 'SET_GUIDE_TO_APP_POPUP_INFO']),
    // 更新数据
    updateData() {
      Indicator.open({
        text: '加载中',
        spinnerType: 'triple-bounce'
      })
      Promise.all([this.fetchEveryWeekData(), this.fetchRecommendCards(), this.fetchData()])
        .then((res) => {
          Indicator.close()
        })
        .catch(() => {
          Indicator.close()
        })
    },
    fetchData() {
      return new Promise((resolve, reject) => {
        FreeCardIndex()
          .then((res) => {
            this.freeCardNum = res.Data.FreeCardNum
            this.friendCardNum = res.Data.FriendCardNum
            this.IsRegisterReceive = res.Data.IsGetNewBoyCard
            this.MoneyCardState = res.Data.MoneyCardState
            this.FreeCardGetStateForWyfl = res.Data.FreeCardGetStateForWyfl
            this.wyflFollowLink = res.Data.WyflUrl
            this.WyflActiveState = res.Data.WyflActiveState
            resolve()
          })
          .catch((e) => {
            reject(e)
          })
      })
    },
    fetchEveryWeekData() {
      return new Promise((resolve, reject) => {
        GetWeekWelfareInfo()
          .then((res) => {
            const { UserLevel, IsGet, Card, LastGetTime, IfShowAppDownloadGuide } = res.Data
            this.userLevel = UserLevel
            this.everyWeekIsReceive = IsGet
            this.weeklyCardNum = Card
            this.SET_IF_SHOW_APP_DOWNLOAD_GUIDE(IfShowAppDownloadGuide)
            if (this.everyWeekIsReceive) {
              let currentTime = moment(LastGetTime)
              if (currentTime.day() < 7 && currentTime.day() > 0) {
                this.showLastTime = `${7 - currentTime.day()}天`
              } else {
                if (currentTime.hour() < 23) {
                  this.showLastTime = `${23 - currentTime.hour()}小时`
                } else {
                  this.showLastTime = `${60 - currentTime.minute()}分钟`
                }
              }
            }
            resolve()
          })
          .catch((e) => {
            reject(e)
          })
      })
    },
    // 获取邀请好友赠送的免单卡数
    fetchRecommendCards() {
      return new Promise((resolve, reject) => {
        GetRecommendSendQty()
          .then((res) => {
            this.recommendCards = res.Msg
            resolve()
          })
          .catch((e) => {
            reject(e)
          })
      })
    },
    // 查看免单卡明细
    checkCardDetail() {
      this.checkLogin(() => {
        // 登录才可进入明细
        this.$router.push({
          name: 'freeCardDetail'
        })
      })
    },
    // 前往0元专区
    goZeroBuyPage() {
      this.$router.push({
        name: 'zeroBuyMain'
      })
    },
    // 去赠送
    toSend() {
      this.checkLogin(() => {
        this.$router.push({
          name: 'ShareByImg',
          query: {
            pageType: 13
          }
        })
      })
    },
    // 领取
    receiveCard(type) {
      // 是否展现预约提醒引导下载APP配置 start
      if (this.getIfShowAppDownloadGuide && !this.getIsApp && type === 3) {
        this.SET_GUIDE_TO_APP_POPUP_INFO({
          isShow: true,
          title: '前往下载APP',
          desc: '每周福利免单卡在APP才能领取哦~',
          isLinkToApp: true
        })
        return
      }
      // 是否展现预约提醒引导下载APP配置 start
      Indicator.open({
        text: '加载中',
        spinnerType: 'triple-bounce'
      })
      BuyerFreeCardGain({ type: type })
        .then((res) => {
          Indicator.close()
          MessageBox({
            title: '领取成功',
            message: `恭喜你已成功领取${res.Msg}张免单卡`,
            showCancelButton: true,
            cancelButtonText: '留在此页',
            confirmButtonText: '立即使用',
            confirmButtonClass: 't_f23030'
          }).then((action) => {
            if (action === 'confirm') {
              this.$router.push({ name: 'zeroBuyMain' })
            } else {
              this.updateData()
            }
          })
        })
        .catch((err) => {
          Indicator.close()
          if (err.ErrMsg.indexOf('更新条目时出错') !== -1) {
            err.ErrMsg = '领取失败，请再重试看看~'
          }
          MessageBox({
            title: '提示',
            message: err.ErrMsg || '请求错误',
            confirmButtonText: '我知道了',
            confirmButtonClass: 't_f23030'
          }).then((action) => {
            if (action === 'confirm') {
              this.updateData()
            }
          })
        })
    },
    // 关注公众号活动免单卡领取
    WyflSubscribeFreeCardGain() {
      Indicator.open({
        text: '加载中',
        spinnerType: 'triple-bounce'
      })
      WyflSubscribeFreeCardGain()
        .then((res) => {
          Indicator.close()
          MessageBox({
            title: '领取成功',
            message: `恭喜你已成功领取1张免单卡`,
            showCancelButton: true,
            cancelButtonText: '留在此页',
            confirmButtonText: '立即使用',
            confirmButtonClass: 't_f23030'
          }).then((action) => {
            if (action === 'confirm') {
              this.$router.push({ name: 'zeroBuyMain' })
            } else {
              this.updateData()
            }
          })
        })
        .catch((err) => {
          Indicator.close()
          if (err.ErrMsg.indexOf('更新条目时出错') !== -1) {
            err.ErrMsg = '领取失败，请再重试看看~'
          }
          MessageBox({
            title: '提示',
            message: err.ErrMsg || '请求错误',
            confirmButtonText: '我知道了',
            confirmButtonClass: 't_f23030'
          }).then((action) => {
            if (action === 'confirm') {
              this.updateData()
            }
          })
        })
    },
    // 去注册
    toRegister() {
      // this.checkLogin()
      if (!this.getIsAuthorized && this.getIsApp) {
        // 弹出授权登录弹窗
        this.AUTHORIZE_POPUP_SHOW(true)
        return
      }
      this.$store.commit('LOGINDIALOG_SHOW', true)
    },
    // 去购买--首页
    toBuy() {
      this.checkLogin(() => {
        this.$router.replace({ name: 'souhuo' })
      })
    },
    // 前往升级说明页面
    goUpgradeDetail() {
      if (this.loginState) {
        this.$router.push({
          name: 'memberUpgrade'
        })
      } else {
        this.unLoginModal()
      }
    },
    // 检测登录
    checkLogin: function(fn) {
      if (this.loginState) {
        if (fn) fn()
      } else {
        this.unLoginModal()
      }
    },
    unLoginModal() {
      if (!this.getIsAuthorized && this.getIsApp) {
        // 弹出授权登录弹窗
        this.AUTHORIZE_POPUP_SHOW(true)
        return
      }
      if (this.getIsAuthorized && this.getIsApp) {
        this.$store.commit('LOGINDIALOG_SHOW', true)
        return
      }
      this.$store.commit('LOGINDIALOG_SHOW', true)
    },
    // 点击跳转到【公众号图文链接 待定】
    checkAboutFollow() {
      if (this.getIsApp) {
        this.$uni.postMessage({
          data: {
            outsideLink: true,
            tempLink: this.wyflFollowLink
          }
        })
      } else {
        window.open(this.wyflFollowLink, '_self')
      }
    }
  }
}
</script>

<style scoped>
@import '../zeroBuy.css';
.t_20a0ff {
  color: #20a0ff;
}
.collar-wrap {
  padding-top: 180px;
  padding-bottom: 22%;
}
.collar-box {
  background: #fff;
  margin: 15px 10px 0 10px;
  border-radius: 10px;
  box-sizing: border-box;
  box-shadow: 0 0 5px 0 #dadada;
}
.collar-title {
  font-size: 16px;
  padding: 10px 15px;
}
.collar-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin: 0 10px;
  padding: 24px 0 24px 10px;
  box-sizing: border-box;
  border-top: 1px solid #f5f5f5;
}
.collar-item .iconfont {
  color: #999;
  font-size: 22px;
}
.collar-item .sent-friend {
  color: #f23030;
}
.collar-item .collar-desc {
  margin-left: 15px;
  font-size: 14px;
}
.collar-desc-title {
  font-size: 14px;
}
.collar-desc-tip {
  color: #999;
  font-size: 13px;
  margin-top: 5px;
}
.collar-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 34px;
  line-height: 34px;
  width: 90px;
  text-align: center;
  font-weight: 600;
  color: #ffc181;
  border-radius: 20px;
  border: 1px solid #ffc181;
  font-size: 13px;
  background: #fff;
}
.collar-item .cancel {
  color: #999;
  border: 1px solid #999;
}
.weui-cell_active {
  background: #f5f5f5;
}
.numTag {
  margin-left: 3px;
}
</style>
